import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import CustomInput from "./CustomInput";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from "@material-ui/core";
import EventLabel from "./EventLabel";

const useStyles = makeStyles((theme) => ({
  paper: {
    position: "absolute",
    width: 400,
    backgroundColor: theme.palette.background.paper,
    border: "2px solid #000",
    boxShadow: theme.shadows[5],
    padding: theme.spacing(2, 4, 3),
  },
}));

export const PasswordDialog = ({ onSuccess, pwd, contentId }) => {
  const [inputValue, setInputValue] = useState("");
  const [showValidationMsg, setShowValidationMsg] = useState(false);
  // getModalStyle is not a pure function, we roll the style only on the first render
  //   const [modalStyle] = React.useState(getModalStyle);

  const handleInput = (e) => {
    setInputValue(e.target.value);
  };
  const onClick = () => {
    if (inputValue === pwd) {
      setShowValidationMsg(false);
      localStorage.setItem(`pwd_${contentId}`, btoa(inputValue));
      onSuccess();
    } else {
      setShowValidationMsg(true);
    }
  };
  const onKeyDown = (e) => {
    if (e.keyCode == 13) onClick();
  };
  return (
    <Dialog open={true} aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title">
        <EventLabel name="PasswordDialogTitle" groupName="CMS.PasswordDialog" />
      </DialogTitle>
      <DialogContent>
        <CustomInput onChange={handleInput} label={<EventLabel name="PasswordInputLabel" groupName="CMS.PasswordDialog" />} value={inputValue} onKeyDown={onKeyDown} />
        {showValidationMsg ? (
          <p style={{ color: "red" }}>
            <EventLabel name="PasswordValidationMsg" groupName="CMS.PasswordDialog" />
          </p>
        ) : null}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClick} color="primary">
          <EventLabel name="PasswordDialogOk" groupName="CMS.PasswordDialog" />
        </Button>
      </DialogActions>
    </Dialog>
  );
};
